import styled from 'styled-components';
import { Shadows } from 'models/StyleModels';
import colors from 'assets/theme/base/colors';

// Main container for the report content
export const ReportContainer = styled.div<{ $breakpointBreached: boolean }>`
  display: flex;
  flex-direction: ${({ $breakpointBreached }) =>
    $breakpointBreached ? 'column' : 'row'};
  height: ${({ $breakpointBreached }) =>
    $breakpointBreached ? 'auto' : '70vh'};
  gap: 2rem;
  padding: 2rem;
`;

// PDF placeholder container
export const PdfPlaceholderContainer = styled.div`
  position: absolute;
  z-index: 2;
  width: 100%;
  height: 100%;
  text-align: center;
  top: 0;
  left: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`;

// Small loader boxes container
export const SmallLoaderBoxesContainer = styled.div`
  width: 100%;
  height: 20%;
  display: flex;
  align-items: center;
  justify-content: space-around;
`;

// Medium loader boxes container
export const MediumLoaderBoxesContainer = styled.div`
  width: 100%;
  height: 20%;
  display: flex;
  align-items: center;
  justify-content: space-around;
`;

// Button grid container for large breakpoint
export const ButtonGridContainer = styled.div`
  margin-top: 1rem;
  display: grid;
  grid-template-columns: 1fr 1fr 1fr 1fr;
  justify-content: center;
  align-items: center;
`;

// PDF viewer container
export const PdfViewerContainer = styled.div<{ $lgBreakpointBreached: boolean }>`
  display: flex;
  flex-direction: column;
  height: 100%;
  width: ${({ $lgBreakpointBreached }) =>
    $lgBreakpointBreached ? '100%' : '60%'};
  margin-bottom: ${({ $lgBreakpointBreached }) =>
    $lgBreakpointBreached ? '1rem' : 0};
`;

// Action buttons container
export const ActionButtonsContainer = styled.div<{ $breakpointBreached: boolean }>`
  display: grid;
  gap: 1rem;
  height: 100%;
  width: ${({ $breakpointBreached }) =>
    $breakpointBreached ? '100%' : '20%'};
  align-items: space-between;
`;

// Complete evaluation button container
export const CompleteEvaluationButtonContainer = styled.div`
  display: grid;
  align-items: flex-end;
`;

// Styled components for existing CSS classes
export const LoaderBoxLg = styled.div`
  &.TriageExamReportPage__LoaderBoxLg {
    /* Add your existing CSS styles here */
  }
`;

export const LoaderBoxSm = styled.div`
  &.TriageExamReportPage__LoaderBoxSm {
    /* Add your existing CSS styles here */
  }
`;

export const LoaderBoxMd = styled.div`
  &.TriageExamReportPage__LoaderBoxMd {
    /* Add your existing CSS styles here */
  }
`;

// Styled MDBox components with specific styling
export const PdfPlaceholder = styled.div<{ $breakpointBreached: boolean }>`
  display: flex;
  flex-direction: column;
  height: ${({ $breakpointBreached }) => $breakpointBreached ? '55vh' : '100%'};
  width: 100%;
  justify-content: space-around;
  align-items: center;
  position: relative;
  border-radius: 8px;
  background-color: ${colors.grey[100]};
  box-shadow: ${Shadows.MEDIUM};
`;

// Styled button components
export const StyledButton = styled.button`
  &.download-button {
    color: ${colors.secondary.main};
  }
  
  &.print-button {
    color: ${colors.secondary.main};
  }
  
  &.exam-room-button {
    margin-top: 1rem;
  }
  
  &.complete-evaluation-button {
    height: fit-content;
    margin-top: 1rem;
  }
  
  &.download-report-button {
    color: ${colors.secondary.main};
    grid-column-start: 2;
  }
  
  &.print-report-button {
    color: ${colors.secondary.main};
    grid-column-start: 3;
  }
`;
